// ** React Imports

// ** Next Imports

// ** MUI Imports
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

// ** Hook Imports

// ** Configs

// ** Custom Components Imports

// ** Third Party Imports

const RekrutmenClosed = () => {
  // ** Hooks
  const theme = useTheme()
  const hiddenSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        py: hiddenSm ? 8 : 8,
        px: hiddenSm ? 4 : 4,
        backgroundColor: theme => theme.palette.error.light,
        borderRadius: 1,
        border: theme => `2px solid ${theme.palette.error.main}`
      }}
    >
      <Typography
        variant={hiddenSm ? 'h6' : 'h4'}
        fontWeight={600}
        letterSpacing={0}
        sx={{ mb: 2, color: theme => theme.palette.error.main, textAlign: 'center' }}
      >
        Rekrutmen ini telah ditutup!
      </Typography>
    </Box>
  )
}

export default RekrutmenClosed
